import WidgetModel from './WidgetModel';

export enum PageKind {
  WelcomePage = 'welcome_page',
  DefaultPage = 'default_page',
  UnsubscribePage = 'unsubscribe_page',
  OnboardingWelcomePage = 'onboarding_welcome',
  WP_ANSWERING_SERVICE = 'wp_answering_service',
  StartBot = 'start_bot',
  AwayResponder = 'away_responder',
  LandingPage = 'landing_page',
  OTNPage = 'otn_page',
  SMSReplyPage = 'sms_reply_page',
  InstagramWelcomer = 'instagram_welcomer',
}

export const MAX_PAGE_SIZE = 9999;
export const HiddenPageKinds: PageKind[] = [];

export type PagePlatform =
  | 'sms'
  | 'facebook'
  | 'instagram'
  | 'webchat'
  | 'email';

export default interface PageModel {
  id: number;
  name: string;
  notes: string;
  botId: number;
  pageGroupId: number;
  kind: PageKind;
  createdAt: string;
  updatedAt: string;
  searchToken: string;
  sortOrder: number;
  widgets?: WidgetModel[];
  abandonedCount: null | number;
  viewsCount: null | number;
  migrated?: boolean;
  useCustomMenu?: boolean;
  platforms: PagePlatform[];
  needsReview?: boolean; // for automation related indicators
}
